import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

type Props = {
  page: number;
  pages: number;
  pageSize: string;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: string) => void;
  position: "top" | "bottom";
};

export function PriceReviewPagination({ page, pages, pageSize, onPageChange, onPageSizeChange, position }: Props) {
  const suffix = position === "top" ? "-top" : "";
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 pt-2 px-2 sm:px-0 text-xs text-muted-foreground">
      <span data-testid={`text-pagination${suffix}`}>Page {page + 1} of {pages}</span>
      <div className="flex items-center gap-2">
        <label className="flex items-center gap-2">
          Rows per page
          <select className="h-8 rounded-md border bg-background px-2 text-xs text-foreground" value={pageSize} onChange={e => onPageSizeChange(e.target.value)} data-testid={`select-proposal-page-size${suffix}`}>
            {["25", "50", "100", "all"].map(size => <option key={size} value={size}>{size === "all" ? "All" : size}</option>)}
          </select>
        </label>
        <Button size="icon" variant="outline" className="h-7 w-7" disabled={page === 0} onClick={() => onPageChange(page - 1)} aria-label="Previous page" data-testid={`button-prev-page${suffix}`}><ChevronLeft className="h-4 w-4" /></Button>
        <Button size="icon" variant="outline" className="h-7 w-7" disabled={page >= pages - 1} onClick={() => onPageChange(page + 1)} aria-label="Next page" data-testid={`button-next-page${suffix}`}><ChevronRight className="h-4 w-4" /></Button>
      </div>
    </div>
  );
}
